/**
 * Hardcoded fixtures for the WFH & Commuting Survey prototype.
 *
 * Numbers are representative of the Unlimited 2024-25 dataset referenced in the PRD
 * (4 locations, ~360 respondents, ~60% response rate). They are not live data.
 */

export const REPORTING_YEARS = [
  { value: '2024-04-01/2025-03-31', label: 'FY 2024-25 (April 2024 - March 2025)' },
  { value: '2025-04-01/2026-03-31', label: 'FY 2025-26 (April 2025 - March 2026)' },
  { value: '2023-04-01/2024-03-31', label: 'FY 2023-24 (April 2023 - March 2024)' },
];

export const LOCATIONS = [
  { id: 'loc-bristol', name: 'Bristol', fte: 157, respondents: 94 },
  { id: 'loc-london', name: 'London', fte: 120, respondents: 72 },
  { id: 'loc-winchester', name: 'Winchester', fte: 65, respondents: 41 },
  { id: 'loc-winnersh', name: 'Winnersh', fte: 50, respondents: 28 },
];

export const CAMPAIGNS = [
  {
    id: 'camp-2025-wfh',
    name: 'FY 2024-25 WFH & Commuting Survey',
    reportingPeriod: 'FY 2024-25',
    status: 'active',
    statusLabel: 'Active',
    createdAt: '2026-04-02',
    deadline: '2026-05-15',
    invitedCount: 392,
    completedCount: 235,
    responseRate: 60,
    locationCount: 4,
    createdBy: 'Sarah Chen',
  },
  {
    id: 'camp-2024-wfh',
    name: 'FY 2023-24 WFH & Commuting Survey',
    reportingPeriod: 'FY 2023-24',
    status: 'closed',
    statusLabel: 'Closed',
    createdAt: '2025-04-10',
    deadline: '2025-05-20',
    closedAt: '2025-05-25',
    invitedCount: 380,
    completedCount: 248,
    responseRate: 65,
    locationCount: 4,
    createdBy: 'Sarah Chen',
  },
  {
    id: 'camp-draft',
    name: 'FY 2025-26 WFH & Commuting Survey',
    reportingPeriod: 'FY 2025-26',
    status: 'draft',
    statusLabel: 'Draft',
    createdAt: '2026-04-15',
    deadline: null,
    invitedCount: 0,
    completedCount: 0,
    responseRate: 0,
    locationCount: 0,
    createdBy: 'Sarah Chen',
  },
  {
    id: 'camp-closing',
    name: 'FY 2024-25 Q2 Pulse Check',
    reportingPeriod: 'Q2 2024',
    status: 'closing',
    statusLabel: 'Calculating',
    createdAt: '2026-03-20',
    deadline: '2026-04-10',
    invitedCount: 392,
    completedCount: 279,
    responseRate: 71,
    locationCount: 4,
    createdBy: 'Sarah Chen',
  },
];

export const INVITATIONS = [
  {
    id: 'inv-1',
    name: 'Aarav Patel',
    email: 'aarav.patel@example.com',
    location: 'Bristol',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-04',
    reminderCount: 0,
  },
  {
    id: 'inv-2',
    name: 'Beth Coleman',
    email: 'beth.coleman@example.com',
    location: 'Bristol',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-05',
    reminderCount: 0,
  },
  {
    id: 'inv-3',
    name: 'Carlos Rivera',
    email: 'carlos.rivera@example.com',
    location: 'London',
    status: 'started',
    sentAt: '2026-04-02',
    reminderCount: 1,
  },
  {
    id: 'inv-4',
    name: 'Deepika Nair',
    email: 'deepika.nair@example.com',
    location: 'London',
    status: 'sent',
    sentAt: '2026-04-02',
    reminderCount: 2,
  },
  {
    id: 'inv-5',
    name: 'Elliot Shaw',
    email: 'elliot.shaw@example.com',
    location: 'Winchester',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-03',
    reminderCount: 0,
  },
  {
    id: 'inv-6',
    name: 'Farrah Okonkwo',
    email: 'farrah.okonkwo@example.com',
    location: 'Winnersh',
    status: 'pending',
    sentAt: null,
    reminderCount: 0,
  },
  {
    id: 'inv-7',
    name: 'Gabriel Romano',
    email: 'gabriel.romano@example.com',
    location: 'Bristol',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-07',
    reminderCount: 1,
  },
  {
    id: 'inv-8',
    name: 'Hana Takeda',
    email: 'hana.takeda@example.com',
    location: 'London',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-08',
    reminderCount: 1,
    flagged: true,
    flagReason: 'Outlier commute distance (>200km)',
  },
  {
    id: 'inv-9',
    name: 'Isaac Bennett',
    email: 'isaac.bennett@example.com',
    location: 'Winchester',
    status: 'sent',
    sentAt: '2026-04-02',
    reminderCount: 1,
  },
  {
    id: 'inv-10',
    name: 'Jin Liu',
    email: 'jin.liu@example.com',
    location: 'Winnersh',
    status: 'completed',
    sentAt: '2026-04-02',
    completedAt: '2026-04-06',
    reminderCount: 0,
  },
];

export const LOCATION_BREAKDOWN = [
  {
    location: 'Bristol',
    fte: 157,
    respondents: 94,
    responseRate: 59.9,
    wfhElectricity: 18.4,
    wfhGas: 24.1,
    wfhOil: 1.2,
    wfhSolidFuel: 0.9,
    wfhCooling: 0.8,
    commuting: 42.7,
    renewablePct: 34,
  },
  {
    location: 'London',
    fte: 120,
    respondents: 72,
    responseRate: 60.0,
    wfhElectricity: 15.1,
    wfhGas: 19.6,
    wfhOil: 0.4,
    wfhSolidFuel: 0.2,
    wfhCooling: 1.1,
    commuting: 28.3,
    renewablePct: 47,
  },
  {
    location: 'Winchester',
    fte: 65,
    respondents: 41,
    responseRate: 63.1,
    wfhElectricity: 7.8,
    wfhGas: 11.2,
    wfhOil: 1.9,
    wfhSolidFuel: 0.5,
    wfhCooling: 0.3,
    commuting: 22.1,
    renewablePct: 29,
  },
  {
    location: 'Winnersh',
    fte: 50,
    respondents: 28,
    responseRate: 56.0,
    wfhElectricity: 6.2,
    wfhGas: 9.4,
    wfhOil: 0.8,
    wfhSolidFuel: 0.3,
    wfhCooling: 0.2,
    commuting: 18.6,
    renewablePct: 31,
  },
];

export const COMMUTING_MODE_SPLIT = [
  { mode: 'Car (Petrol)', km: 184320, tco2e: 34.2, pct: 39 },
  { mode: 'Car (Diesel)', km: 72480, tco2e: 14.8, pct: 15 },
  { mode: 'Car (Hybrid)', km: 41200, tco2e: 4.1, pct: 9 },
  { mode: 'Car (BEV)', km: 28400, tco2e: 1.9, pct: 6 },
  { mode: 'Train', km: 98640, tco2e: 5.4, pct: 21 },
  { mode: 'Bus', km: 22100, tco2e: 2.3, pct: 5 },
  { mode: 'Cycle', km: 14800, tco2e: 0, pct: 3 },
  { mode: 'Walk', km: 6400, tco2e: 0, pct: 2 },
];

export const RESPONDENT_DRILL_DOWN = {
  id: 'resp-1',
  name: 'Aarav Patel',
  location: 'Bristol',
  employmentType: 'Full period',
  weeksWorked: 46,
  workPattern: { daysPerWeek: 5, wfhDays: 3, commuteDays: 2 },
  wfh: {
    equipmentKwh: 184.2,
    videoKwh: 12.6,
    lightingKwh: 96.8,
    electricHeatingKwh: 0,
    gasKwh: 812.4,
    oilKwh: 0,
    solidFuelKwh: 0,
    coolingKwh: 0,
    totalTco2e: 0.248,
  },
  commuting: {
    legs: [
      { order: 1, mode: 'Walk', distance: 0.6, annualKm: 55, tco2e: 0 },
      { order: 2, mode: 'Train', distance: 18.4, annualKm: 3389, tco2e: 0.128 },
      { order: 3, mode: 'Walk', distance: 0.4, annualKm: 37, tco2e: 0 },
    ],
    totalKm: 3481,
    totalTco2e: 0.128,
  },
  renewableFlag: 'National Grid',
  submittedAt: '2026-04-04T09:14:00Z',
};

export const OFFICE_OPTIONS = LOCATIONS.map((l) => ({ value: l.id, label: l.name }));

export const MONTH_OPTIONS = [
  'April 2024', 'May 2024', 'June 2024', 'July 2024', 'August 2024', 'September 2024',
  'October 2024', 'November 2024', 'December 2024', 'January 2025', 'February 2025', 'March 2025',
].map((m) => ({ value: m, label: m }));

export const BULB_OPTIONS = [
  { value: 'led', label: 'LEDs' },
  { value: 'cfl', label: 'CFLs (Compact Fluorescent)' },
  { value: 'halogen', label: 'Halogen' },
  { value: 'tungsten', label: 'Tungsten (Incandescent)' },
  { value: 'unknown', label: "Don't Know" },
];

export const FUEL_OPTIONS = [
  { value: 'gas', label: 'Gas' },
  { value: 'electricity', label: 'Electricity' },
  { value: 'oil', label: 'Oil' },
  { value: 'solid', label: 'Wood / Solid Fuel' },
  { value: 'heatpump', label: 'Heat Pump' },
  { value: 'none', label: 'None' },
  { value: 'unknown', label: "Don't Know" },
];

export const VIDEO_HOURS_OPTIONS = [
  { value: '0-5', label: '0 to 5 hours' },
  { value: '6-10', label: '6 to 10 hours' },
  { value: '11-15', label: '11 to 15 hours' },
  { value: '16-20', label: '16 to 20 hours' },
  { value: '20+', label: '20+ hours' },
];

export const SELF_GEN_OPTIONS = [
  { value: '<25', label: 'Less than 25%' },
  { value: '25-50', label: '25% to 50%' },
  { value: '50-75', label: '50% to 75%' },
  { value: '>75', label: 'More than 75%' },
  { value: 'unknown', label: "Don't Know" },
];

export const TRANSPORT_MODE_OPTIONS = [
  { value: 'walk', label: 'Walk' },
  { value: 'cycle', label: 'Cycle' },
  { value: 'ebike', label: 'E-Bike' },
  { value: 'car', label: 'Car' },
  { value: 'motorbike', label: 'Motorbike' },
  { value: 'bus', label: 'Bus' },
  { value: 'coach', label: 'Coach' },
  { value: 'train', label: 'Train' },
  { value: 'taxi', label: 'Taxi' },
  { value: 'van', label: 'Van' },
];

export const CAR_SIZE_OPTIONS = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
  { value: 'average', label: 'Average (unknown size)' },
];

export const CAR_FUEL_OPTIONS = [
  { value: 'petrol', label: 'Petrol' },
  { value: 'diesel', label: 'Diesel' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'phev', label: 'Plug-in Hybrid (PHEV)' },
  { value: 'bev', label: 'Battery Electric (BEV)' },
  { value: 'lpg', label: 'LPG' },
];

export const statusVariant = (status) => {
  switch (status) {
    case 'active':
      return 'info';
    case 'closing':
      return 'warning';
    case 'closed':
      return 'success';
    case 'draft':
      return 'outline';
    case 'reopened':
      return 'warning';
    case 'completed':
      return 'success';
    case 'started':
      return 'info';
    case 'sent':
      return 'secondary';
    case 'pending':
      return 'outline';
    default:
      return 'default';
  }
};

export const prettyDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch (e) {
    return iso;
  }
};

export const totalTco2e = (row) =>
  Number(
    (row.wfhElectricity + row.wfhGas + row.wfhOil + row.wfhSolidFuel + row.wfhCooling + row.commuting).toFixed(1),
  );

export const sumCampaignTotals = () => {
  return LOCATION_BREAKDOWN.reduce(
    (acc, row) => ({
      wfhElectricity: acc.wfhElectricity + row.wfhElectricity,
      wfhGas: acc.wfhGas + row.wfhGas,
      wfhOil: acc.wfhOil + row.wfhOil,
      wfhSolidFuel: acc.wfhSolidFuel + row.wfhSolidFuel,
      wfhCooling: acc.wfhCooling + row.wfhCooling,
      commuting: acc.commuting + row.commuting,
    }),
    { wfhElectricity: 0, wfhGas: 0, wfhOil: 0, wfhSolidFuel: 0, wfhCooling: 0, commuting: 0 },
  );
};
